import { Search, Bell, User } from "lucide-react";

const Topbar = () => {
  return (
    <header className="h-16 bg-white flex items-center justify-between px-6 shadow-sm">
      {/* Search */}
      <div className="flex items-center w-full max-w-md bg-gray-100 rounded-lg px-3 py-2">
        <Search size={18} className="text-gray-500" />
        <input
          type="text"
          placeholder="Search registrations, users, reports..."
          className="bg-transparent outline-none ml-2 text-sm w-full"
        />
      </div>

      {/* Actions */}
      <div className="flex items-center gap-4">
        <button className="relative">
          <Bell size={20} />
          <span className="absolute -top-1 -right-1 h-2 w-2 bg-red-500 rounded-full" />
        </button>

        <button>
          <User size={20} />
        </button>
      </div>
    </header>
  );
};

export default Topbar;
